import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { CustomerDetailBreadcrumbProvider } from "@/features/customers/CustomerDetailBreadcrumbContext";
import { AccountManagerProfileBreadcrumbProvider } from "@/features/account-managers/AccountManagerProfileBreadcrumbContext";
import { PageLoading } from "@/components/ui/PageLoading";
import { AdminSidebar } from "./AdminSidebar";
import { AdminTopBar } from "./AdminTopBar";
import styles from "./AdminLayout.module.css";

export function AdminLayout() {
  return (
    <CustomerDetailBreadcrumbProvider>
      <AccountManagerProfileBreadcrumbProvider>
        <div className={styles.root} data-testid="admin-layout">
          <AdminSidebar />
          <div className={styles.main} data-testid="admin-layout-main">
            <div className={styles.mainChrome}>
              <AdminTopBar />
            </div>
            <div className={styles.mainScroll} data-testid="admin-layout-scroll">
              <Suspense fallback={<PageLoading />}>
                <Outlet />
              </Suspense>
            </div>
          </div>
        </div>
      </AccountManagerProfileBreadcrumbProvider>
    </CustomerDetailBreadcrumbProvider>
  );
}
